import _isNil from 'lodash/isNil';
import _has from 'lodash/has';
import { ChartSeries } from './index';
import type {
    IBubbleChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/bubble-chart.interface';
import type { IBubbleChartSerData, ICTNumData, ICTNumDataSource } from '@tencent/slide-sdk-model';
import type { SerRules } from './index';

export class BubbleChartSeries extends ChartSeries implements IBubbleChartSeries {
    public static convertDataUiToSdk(uiData) {
        const sdkData = super.convertDataUiToSdk(uiData);

        if (_has(uiData, 'bubbleSize')) {
            if (uiData.bubbleSize) {
                sdkData.bubbleSize = BubbleChartSeries.getSdkBubbleSize(uiData.bubbleSize);
            } else {
                sdkData.bubbleSize = uiData.bubbleSize;
            }
        }

        return sdkData;
    }

    public static getSdkBubbleSize(sizes: Array<string|number|undefined>): ICTNumDataSource {
        return {
            numRef: {
                numCache: {
                    ptCount: { val: sizes?.length || 0 },
                    pt: sizes?.map((value, idx) => ({
                        idx,
                        v: (value || value === 0) ? String(value) : value as string,
                    })).filter(point => !!point.v),
                    formatCode: 'General',
                },
            },
        };
    }

    public bubbleSize: (number|undefined)[];

    public constructor(serData: IBubbleChartSerData, options: SerRules) {
        super(serData, options);
        const { bubbleSize } = serData;
        this.bubbleSize = [
            ...Array(this.getBubbleSizeDataSource(bubbleSize)?.ptCount?.val),
        ].map((item, index) => {
            const point = this.getBubbleSizeDataSource(bubbleSize)?.pt?.find(point => point.idx === index);
            if (!point || _isNil(point.v) || point.v === '' || isNaN(Number(point.v))) {
                return;
            }

            return Number(point.v);
        });
    }

    public setDataList(series: IBubbleChartSerData, options: SerRules) {
        super.setDataList(series, options);

        this.dataList.forEach((uiDataItem) => {
            if (_has(uiDataItem, 'valuePoint.value') && !_isNil(uiDataItem.valuePoint?.value) && uiDataItem.valuePoint?.value !== '') {
                const numberValue = Number(uiDataItem.valuePoint!.value);
                if (!isNaN(numberValue)) {
                    uiDataItem.valuePoint!.value = numberValue;
                }
            }

            if (_has(uiDataItem, 'categoryPoint.value') && !_isNil(uiDataItem.categoryPoint?.value) && uiDataItem.categoryPoint?.value !== '') {
                const numberValue = Number(uiDataItem.categoryPoint!.value);
                if (!isNaN(numberValue)) {
                    uiDataItem.categoryPoint!.value = numberValue;
                }
            }
        });
    }

    private getBubbleSizeDataSource(bubbleSize?: ICTNumDataSource): ICTNumData | undefined {
        return bubbleSize?.numLit || bubbleSize?.numRef?.numCache;
    }
}
